import { CubesRepository, DimensionsRepository } from '../repositories/koob';
import { BaseEntitiesService } from './BaseEntitiesService';
import { createObjectsCache, createSingleton } from '../singleton';
export class CubesService extends BaseEntitiesService {
    constructor() {
        super(new CubesRepository());
    }
    static getInstance = createSingleton(() => new CubesService(), '__koobCubesService');
}
export class DimensionsService extends BaseEntitiesService {
    source_ident;
    cube_name;
    constructor(source_ident, cube_name) {
        super(new DimensionsRepository(source_ident, cube_name));
        this.source_ident = source_ident;
        this.cube_name = cube_name;
    }
    _dispose() {
        DimensionsService._cache.remove(this.source_ident, this.cube_name);
        super._dispose();
    }
    static _cache = createObjectsCache((source_ident, cube_name) => new DimensionsService(source_ident, cube_name), '__koobDimensionsService');
    static createInstance = DimensionsService._cache.get;
}
